import { render, staticRenderFns } from "./TableH.vue?vue&type=template&id=6c06b936&scoped=true&"
import script from "./TableH.vue?vue&type=script&lang=js&"
export * from "./TableH.vue?vue&type=script&lang=js&"
import style0 from "./TableH.vue?vue&type=style&index=0&id=6c06b936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c06b936",
  null
  
)

export default component.exports